import { put, all, select } from 'redux-saga/effects';

const STANDARD_REPORT = {
  id: 'PARCEL_REPORT',
  sections: [
    {
      title: 'Property Profile',
      properties: [
        {
          column: 'parcel_id',
          type: 'HIDDEN',
        },
        {
          column: 'add_combo',
          label: 'Address',
          type: 'TEXT',
        },
        {
          column: 'owner_name',
          label: 'Owner',
          type: 'TEXT',
        },
      ],
    },
  ],
};

const getReports = ({ reports }) => (reports == null ? [STANDARD_REPORT] : reports);

export function* fetchFavorites() {
  const ids = yield select(({ starredParcels }) => starredParcels);
  const reports = yield select(getReports);
  const report = reports.find(({ id }) => id === 'PARCEL_REPORT');

  const identifier = report.identifier || 'parcel_id';

  yield all(
    ids.map((id) => put({
        type: 'FETCH_PARCEL_FOR_REPORT',
        payload: {
          config: {
            [identifier]: id,
            identifier,
            report,
          },
        },
      })),
  );
}
